/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../../Router/all_routes";
import { bucketObj } from "../../../environment";

import imageCompression from 'browser-image-compression'; 
// eslint-disable-next-line no-unused-vars
import ImageWithBasePath, {uploadImage,uploadImageNew, getImageURL} from "../../../core/img/imagewithbasebath";
import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
  Info,
  LifeBuoy,
  PlusCircle,
  X,
} from "feather-icons-react/build/IconComponents";
import { setToogleHeader, set_page_refresh } from "../../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {set_store_list, set_supplier_list, set_brand_list, set_variant_list} from "../../../core/redux/action";
import Spinner from "../../../feature-module/loader/spinner";
import { useNavigate } from "react-router-dom";

const EditStore = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");

  const choose = t?.[l]?.["choose"]

  const navigate = useNavigate();

  const [product, setProduct] = useState({})
  const [check, setCheck] = useState(false)
  
  const [imageLoading] = useState(0)
  const [imageData, setImageData] = useState([])

  const category = useSelector((state) => [{label: choose, value: "choose"}].concat(state.category_list?.map((itm) => { return {label: itm.name, value: itm._id}})));
  const subcategory = useSelector((state) => state.subcategory_list);
  const [subCatOpts, setSubCatOpts] = useState([{label: choose, value: "choose"}])
  const supplier = useSelector((state) => [{label: choose, value: "choose"}].concat(state.supplier_list?.map((itm) => { return {label: itm.name, value: itm._id}})));
  const store = useSelector((state) => [{label: choose, value: "choose"}].concat(state.store_list?.map((itm) => { return {label: itm.name, value: itm._id}})));
  const brand = useSelector((state) => [{label: choose, value: "choose"}].concat(state.brand_list?.map((itm) => { return {label: itm.name, value: itm._id}})));
  const variant = useSelector((state) => [{label: choose, value: "choose"}].concat(state.variant_list?.map((itm) => { return {label: itm.name, value: itm._id, attributes: itm.attributes,customized: itm.customized}})));
  const [attributes, setAttributes] = useState([{label: choose, value: "choose"}])
  const data = useSelector((state) => state.toggle_header);
  const handleRemoveProduct = (name, index) => {
    setImageData(prevState => ({
      ...prevState,
      [name]: ""
    })); 
    
    let imgs1 = JSON.parse(JSON.stringify(product.imgUrls.filter((_,n) => n!== index)))
    setProduct(prevState => ({
      ...prevState,
      // ["images"]: imgs,
      ["imgUrls"]:imgs1,
    }));
  };
  
  const prodData = useSelector((state) => state.product_edit)
  
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  async function handleFileUpload(event) {
    try {
    if(event.target.files.length) {
      const file = event.target.files[0];
       // Check the file size
       if (file.size > 5242880) {//5mb
        alert(t?.[l]?.["file_size_exceeds_5_mb_limit"] || "File size exceeds 5 MB limit");
        event.target.value = ''; // Clear the file input
        return;
    }

      // Image compression options
      const options = {
        maxSizeMB: 1, // Adjust the max size as needed
        maxWidthOrHeight: 500, // Adjust dimensions as needed
        useWebWorker: true
      };
      const compressedFile = await imageCompression(file, options);
      let name = await uploadImageNew(compressedFile,'store','img');
      event.target.value = '';
  
      let imgs = JSON.parse(JSON.stringify(product?.imgUrls || []));
      imgs.push(name);
      setProduct(prevState => ({
        ...prevState,
        ["imgUrls"]: imgs
      }));
    }

    } catch (error) {
      console.error('Error compressing image:', error);
    }
  }
  const goBack = () => {
    navigate("/product-list")
  }
  const [productType, setProductType] = useState("single");

  const handleProductTypeChange = (e) => {
    const selectedType = e.target.value;
    setProductType(selectedType);

    if (selectedType === "single" || selectedType === "variable" || selectedType === "custom") {
      handleInputChange({ target: { name: "variantId", value: "" } });
      handleInputChange({ target: { name: "variantName", value: "" } });
      handleInputChange({ target: { name: "attribute", value: [] } });
      setAttributes([{ label: choose, value: "choose" }]);
    }
  };

  const submit= async (event) => {
    const form = event.currentTarget;
    event.preventDefault()
    event.stopPropagation()
    try {
      if(form?.checkValidity()) {
        product.productType=productType;
        // Iterate over the attribute array in obj1
        if(product?.attribute && product?.productType == 'custom')
        {
          let customizedData = {};
          product?.attribute?.forEach(attr => {
            customizedData[attr.value.trim()] = "";
          });
          product.customizedData = customizedData;
        }
        console.log('New product',product);
        await axios.post('addproduct/', product);
        dispatch(set_page_refresh("productlist"))
        goBack()
      }
    } catch(e) {
      console.log(e)
      return false;
    }
    

    return false;
  }
  useEffect(() => {
    async function fetchImages() {
      if(typeof product.imgUrls == "object") {
        setImageData(product.imgUrls)

      }
    }
    fetchImages()
  }, [product])

  useEffect(() => {
    if(prodData) {
      if(prodData.categoryId) {
        setSubCatOpts([{label: choose, value: "choose"}].concat(subcategory?.filter((itm) => itm.categoryId == prodData.categoryId).map((itm) => {
          return {value: itm._id, label: itm.name}
        })))
      }
      if(prodData?._id && (!prodData?.attributeValue ||prodData?.attributeValue == ""))
        {
          setCheck(true); 
          console.log('test');
        }
        else  
          setCheck(false); 
      if(prodData?.variantId) {
        
        setAttributes([{label: choose, value: "choose"}].concat(variant?.filter((itm) => itm?.value == prodData.variantId)?.[0]?.attributes?.split(",").map((v) => ({value: v, label: v}))));
                          
      }
      setProduct( prodData )
      if(typeof prodData.images == "string") {
        setProduct(prevState => ({
          ...prevState,
          ["images"]: JSON.parse(prodData.images || [])
        }));
      }
    }
  }, [prodData])


  useEffect(() => {
    async function fetchData() {
      try {
        const [ stores, suppliers, brands, variants] = await Promise.all([
          // categories, subcategories,
          // axios.get("getusercategories/"),
          // axios.get("getusersubcategories/"),
          axios.get("getuserstores/"),
          axios.get("getusersuppliers/"),
          axios.get("getuserbrands/"),
          axios.get("getuservariants/")
        ]);
        // dispatch(set_category_list(categories.data));
        // dispatch(set_subcategory_list(subcategories.data));
        dispatch(set_store_list(stores.data));
        dispatch(set_supplier_list(suppliers.data));
        dispatch(set_brand_list(brands.data));
        dispatch(set_variant_list(variants.data));
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, [dispatch]);
  const handleInputChange = (e) => {
    const { name, type, checked, value } = e.target;

    if (type === 'checkbox') {
      setProduct(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else {
      setProduct(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const discounttype = [
    { value: "choose", label: choose },
    { value: "percentage", label: t?.[l]?.["percentage"] || "Percentage" },
    // { value: "cash", label: t?.[l]?.["cash"] || "Cash" },
  ];
  return (
    <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
      
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>{t?.[l]?.["new_product"] || "New Product"}</h4>
              <h6>{t?.[l]?.["create_new_product"] || "Create new product"}</h6>
            </div>
          </div>
          <ul className="table-top-head">
            
            <li>
              <div className="page-btn">
                <Link to={route.productlist} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  {t?.[l]?.["back_to_product"] || "Back to Product"}
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
        {/* /add */}
        <form onSubmit={submit}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div
                className="accordion-card-one accordion"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-controls="collapseOne"
                    >
                      <div className="addproduct-icon">
                        <h5>
                          <Info className="add-info" />

                          <span>{t?.[l]?.["product_information"] || "Product Information"}</span>
                        </h5>
                        <Link to="#">
                          <ChevronDown className="chevron-down-add" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                    <div className="addservice-info">
                        <div className="row">
                          <div className="col-12">
                            <div className=" mb-3 add-product">
                              <label className="form-label">{t?.[l]?.["product_name"] || "Product Name"}</label>
                              <input type="text" className="form-control" value={product.name} required name="name" onChange={handleInputChange}/>
                            </div>
                          </div>
                          
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className=" mb-3 add-product">
                            <label className="form-label">{t?.[l]?.["store"] || "Store"}</label>
                            <Select
                              className="select"
                              options={store}
                              placeholder={choose}
                              
                              value = {
                                store?.filter(option => 
                                  option?.value === product.storeId)
                              }
                              onChange={(v) => {
                                handleInputChange({target: {name: "storeId", value: v.value}})
                                handleInputChange({target: {name: "storeName", value: v.label}})
                              }} />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["supplier"] || "Supplier"}</label>
                            </div>
                            <Select
                              className="select"
                              options={supplier}
                              placeholder={choose}
                              name="discounttype" 
                              value = {
                                supplier?.filter(option => 
                                  option?.value === product.supplierId)
                              }
                              onChange={(v) => {
                                handleInputChange({target: {name: "supplierId", value: v.value}})
                                handleInputChange({target: {name: "supplierName", value: v.label}})
                              }} />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["category"] || "Category"}</label>
                            </div>
                            <Select
                              className="select"
                              options={category}
                              placeholder={choose}
                              required
                              value = {
                                category?.filter(option => 
                                  option?.value === product.categoryId)
                              }
                              onChange={(v) => {
                                if(v.value) {
                                  setSubCatOpts([{label: choose, value: "choose"}].concat(subcategory.filter((itm) => itm.categoryId == v.value).map((itm) => {
                                    return {value: itm._id, label: itm.name}
                                  })))
                                }
                                handleInputChange({target: {name: "categoryId", value: v.value}})
                                handleInputChange({target: {name: "categoryName", value: v.label}})
                              }} />
                          </div>
                        </div>
                        
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["sub_category"] || "Sub Category"}</label>
                            </div>
                            <Select
                              className="select"
                              options={subCatOpts}
                              placeholder={choose}
                              isDisabled={subCatOpts.length < 2}
                              value = {
                                subCatOpts?.filter(option => 
                                  option?.value === product.subCategoryId)
                              }
                              onChange={(v) => {
                                handleInputChange({target: {name: "subCategoryId", value: v.value}})
                                handleInputChange({target: {name: "subCategoryName", value: v.label}})
                              }} />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <div className="add-newplus">
                              <label className="form-label">{t?.[l]?.["brands"] || "Brands"}</label>
                            </div>
                            <Select
                              className="select"
                              options={brand}
                              placeholder={choose}
                              required
                              value = {
                                brand?.filter(option => 
                                  option?.value === product.brandId)
                              }
                              onChange={(v) => {
                                handleInputChange({target: {name: "brandId", value: v.value}})
                                handleInputChange({target: {name: "brandName", value: v.label}})
                              }} />
                          </div>
                        </div>
                       
                      </div>
                      <div className="row">
                          <div className="col-lg-12 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <div className="status-toggle modal-status d-flex align-items-center">
                                    <span className="status-label">{t?.[l]?.["featured"] || "Featured"}</span>
                                    <input
                                        type="checkbox"
                                        id="featured"
                                        name="featured"
                                        className="check"
                                        
                                        checked={product.featured} 
                                        onChange={handleInputChange}
                                    />
                                  <label
                                    style={{
                                      marginLeft: l === 'ar' ? '' : '7px',
                                      marginRight: l === 'ar' ? '16px' : '' // Adjust this as needed
                                    }}

                                     htmlFor="featured" className="checktoggle" />


                                </div>
                              </div>
                          </div>
                          
                          <div className="col-lg-12 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                            <div className="status-toggle modal-status d-flex align-items-center">
                                <span className="status-label">{t?.[l]?.["special"] || "Special"}</span>
                                <input
                                    type="checkbox"
                                    id="special"
                                    name="special"
                                    className="check"
                                   
                                    defaultValue={false}
                                    checked={product.special} 
                                    onChange={handleInputChange}
                                />
                                <label  
                                style={{
                                  marginLeft: l === 'ar' ? '' : '15px',
                                  marginRight: l === 'ar' ? '13px' : '' // Adjust this as needed
                                }} htmlFor="special" className="checktoggle" />
                            </div>

                            </div>
                          </div>
                        </div>
                      {/* Editor */}
                      <div className="col-lg-12">
                        <div className="input-blocks summer-description-box transfer mb-3">
                          <label>{t?.[l]?.["description"] || "Description"}</label>
                          <textarea
                            className="form-control h-100"
                            rows={5}
                            maxLength={1000}
                            defaultValue={""}
                            value={product.description} name="description" onChange={handleInputChange}
                          />
                          <p className="mt-1">{t?.[l]?.["maximum_1000_characters"] || "Maximum 1000 Characters"}</p>
                        </div>
                      </div>
                      
                      {/* /Editor */}
                      <div
                                id="collapseThree"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample3"
                              >
                                <div className="accordion-body">
                                  <div className="text-editor add-list add">
                                    <div className="col-lg-12">
                                      <div className="add-choosen">
                                        <div className="input-blocks">
                                          <div className="image-upload">
                                            <input type="file" 
                                            accept="image/png,image/jpg,image/gif,image/jpeg,image/svg"
                                            onChange={handleFileUpload} />
                                            <div className="image-uploads">
                                              <PlusCircle className="plus-down-add me-0" />
                                              <h4>{t?.[l]?.["add_images"] || "Add Images"}</h4>
                                            </div>
                                          </div>
                                          {imageLoading > 0 && <Spinner/>}
                                        </div> 
                                        
                                        {imageData && imageData.length > 0 && imageData.map((key,index) => {
                                            // if(imageData[key]) {
                                              return <div className="phone-img border rounded p-2" key={index}>
                                                <ImageWithBasePath
                                                  src={bucketObj.bucketUrl+bucketObj.objectKey+key}
                                                  alt={key}
                                                  absolutePath="true"
                                                  className="img-fluid-phone-img"
                                                />
                                                <Link to="#">
                                                  <X
                                                    className="x-square-add remove-product"
                                                    onClick={() => {handleRemoveProduct(key, index)}}
                                                  />
                                                </Link>
                                              </div>
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
   
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="accordion-card-one accordion"
                id="accordionExample2"
              >
                <div className="accordion-item">

                  <div className="accordion-header" id="headingTwo">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-controls="collapseTwo"
                    >
                      <div className="text-editor add-list">
                        <div className="addproduct-icon list icon">
                          <h5>
                            <LifeBuoy className="add-info" />
                            <span>{t?.[l]?.["pricing"] || "Pricing"}</span>
                          </h5>
                          <Link to="#">
                            <ChevronDown className="chevron-down-add" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                 
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample2"
                  >
                    <div className="accordion-body">
                      
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div className="row">
                            <div className="col-12">
                              <div className="mb-4">
                                <label className="form-label">Product Type</label>
                                <div className="d-flex align-items-center flex-wrap">
                                <label className="form-label me-3 d-flex align-items-center">

                                    <input
                                      type="radio"
                                      name="productType"
                                      value="single"
                                      checked={productType === "single"}
                                      onChange={handleProductTypeChange}
                                    />
                                    &nbsp;&nbsp; Single Product
                                  </label>
                                  <label className="form-label me-3 d-flex align-items-center">
                                  <input
                                      type="radio"
                                      name="productType"
                                      value="variable"
                                      checked={productType === "variable"}
                                      onChange={handleProductTypeChange}
                                    />
                                    &nbsp;&nbsp; Variable Product
                                  </label>
                                  <label className="form-label me-3 d-flex align-items-center">
                                  <input
                                      type="radio"
                                      name="productType"
                                      value="custom"
                                      checked={productType === "custom"}
                                      onChange={handleProductTypeChange}
                                    />
                                    &nbsp;&nbsp; Custom Product
                                    </label>
                                  </div>
                              </div>
                            </div>
                            
                            {productType !== "single" && (
                                <div className="row">
                              <div className="col-lg-4 col-sm-6 col-12">
                                <div className="input-blocks add-product">
                                  <label>{t?.[l]?.["variant"] || "Variant"}</label>
                                  <Select
                                    className="select"
                                    options={
                                      variant?.filter(option => 
                                        productType === "custom" 
                                          ? option.customized === true 
                                          : option.customized === false || option.customized == null
                                      ) || []
                                    }
                                    placeholder={choose}
                                    value = {
                                      variant?.filter(option => 
                                        option?.value === product.variantId)
                                    }
                                    isDisabled={check}
                                    onChange={(v) => {
                                      if(v.attributes) {
                                        handleInputChange({ target: { name: "attribute", value: [] } });
                                        setAttributes([{label: choose, value: "choose"}].concat(v.attributes.split(",").map((v) => ({value: v, label: v}))));
                                      }
                                      handleInputChange({target: {name: "variantId", value: v.value}})
                                      handleInputChange({target: {name: "variantName", value: v.label}})
                                    }} />
                                </div>
                              </div>
                              <div className="col-lg-4 col-sm-6 col-12">
                                <div className="input-blocks add-product">
                                    <label>{t?.[l]?.["attributes"] || "Attributes"}</label>
                                  
                                  <Select
                                    className="select"
                                    options={attributes}
                                    isMulti
                                    placeholder={choose}
                                    name="discounttype" 
                                    isDisabled={attributes?.length < 2}
                                    value = {product.attribute}
                                    onChange={(v) => {
                                      console.log(v)
                                      handleInputChange({target: {name: "attribute", value: v}})
                                    }} />
                                </div>
                              </div>
                           
                              </div>
                             )}

                        
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="input-blocks add-product">
                                <label>{t?.[l]?.["price"] || "Price"}</label>
                                <input type="number" className="form-control" value={product.price} required name="price" onChange={handleInputChange}/>
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="input-blocks add-product">
                                <label>{t?.[l]?.["discount_type"] || "Discount Type"}</label>
                                <Select
                                  className="select"
                                  options={discounttype}
                                  placeholder={choose}
                                  
                                  name="discounttype" 
                                  value = {
                                    discounttype?.filter(option => 
                                      option.value === product.discountType)
                                  }
                                  onChange={(v) => {
                                    handleInputChange({target: {name: "discountType", value: v.value}})
                                  }} />
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="input-blocks add-product">
                                <label>{t?.[l]?.["discount_value"] || "Discount Value"}</label>
                                <input type="number" className="form-control" value={product.discountValue} name="discountValue" onChange={handleInputChange}/>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-4 col-sm-6 col-12">
                                <div className="input-blocks add-product">
                                  <label>{t?.[l]?.["status"] || "Status"}</label>
                                  <Select
                                    className= "select"
                                    options= {[
                                      { value: 'active', label: t?.[l]?.["active"] || "Active" },
                                      { value: 'inactive', label: t?.[l]?.["inactive"] || "Inactive" }
                                    ]}
                                    placeholder= {choose}
                                    value= {product.pStatus ? { value: product.pStatus, label: t?.[l]?.[product.pStatus] || product.pStatus.charAt(0).toUpperCase() + product.pStatus.slice(1) } : null}
                                    onChange={(v) => {
                                      handleInputChange({ target: { name: 'pStatus', value: v.value } });
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-4 col-sm-6 col-12">
                                <div className="input-blocks add-product">
                                  <label>{t?.[l]?.["weight"] || "Weight (kg)"}</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={product.weight || ''}
                                    name="weight"
                                    maxLength={4}
                                    onChange={handleInputChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button type="button" className="btn btn-cancel me-2" onClick={goBack}>
                {t?.[l]?.["cancel"] || "Cancel"}
              </button>
              <button type="submit" className="btn btn-submit">
              {t?.[l]?.["save"] || "Save"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditStore;